/**
 * SEO 配置 - chat (繁體中文)
 */

export default {
    chat: {
        title: 'AI 對話 - 多模型智慧助手 | WeryAI',
        description:
            '在 WeryAI 與多個頂尖 AI 模型同時對話，支援多視窗並排比較回覆。一站式生成圖片、影片和音樂，開啟高效 AI 創作體驗。免費使用。',
        keywords:
            'AI 對話, AI 聊天, 多模型對話, AI 助手, 智慧助手, 並排比較 AI, AI 工作台, 免費 AI 聊天, WeryAI',
        og_title: 'AI 對話 - 多模型智慧助手 | WeryAI',
        og_description:
            '與多個頂尖 AI 模型同時對話，多視窗並排比較。一站式生成圖片、影片和音樂。免費體驗 WeryAI。',
        twitter_title: 'AI 對話 - 多模型智慧助手 | WeryAI',
        twitter_description:
            '與多個頂尖 AI 模型同時對話，多視窗並排比較。一站式生成圖片、影片和音樂。免費體驗 WeryAI。',
    },
}
